import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPersonCarry } from '@fortawesome/pro-solid-svg-icons/faPersonCarry';
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import classnames from 'classnames';
import { noop } from 'ui-components/default-props/noop';
import Address from '../../components/address';
import { LabeledInfo } from 'ui-components/components/labeled-info';
import AddressValidationSection from './address-validation';
import { usePickupRelayOrderInfoByFulfillmentPlanId } from '../../hooks/orders/use-pickup-relay-order-check';

import style from './ship-to.module.less';
import { emptyObject } from 'ui-components/default-props/empty';

const messages = defineMessages({
  shipTo: {
    description: 'orderDetails.shipTo',
    defaultMessage: 'Ship To',
    id: 'Tk+nRf',
  },
  shipFrom: {
    description: 'orderDetails.shipFrom',
    defaultMessage: 'Ship From',
    id: 'GHRKmn',
  },
});

const ShipTo = ({
  data = emptyObject,
  className = '',
  fulfillmentPlanId,
  validateAddress = noop,
  hideAddressValidation = false,
  isReturn = false,
}) => {
  const intl = useIntl();
  const labelMessage = isReturn ? messages.shipFrom : messages.shipTo;
  const isPickupRelayOrder = usePickupRelayOrderInfoByFulfillmentPlanId(fulfillmentPlanId) !== null;

  return (
    <div className={classnames(style['ship-to'], className)}>
      <LabeledInfo label={intl.formatMessage(labelMessage)} showMdash={!data}>
        <Address address={data} />
        {isPickupRelayOrder && data?.line1 && (
          <div className={style['pickup-relay-info']}>
            <FontAwesomeIcon icon={faPersonCarry} />
            <span>Validated</span>
          </div>
        )}
      </LabeledInfo>
      {!hideAddressValidation && (
        <AddressValidationSection
          countryCode={data.countryCode}
          residentialIndicator={data.residentialIndicator}
          shipToAddress={data}
          validateAddress={validateAddress}
          validation={data.verificationStatus}
          validationMessage={data.verificationMessage}
        />
      )}
    </div>
  );
};

ShipTo.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
  validateAddress: PropTypes.func,
  hideAddressValidation: PropTypes.bool,
  isReturn: PropTypes.bool,
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default ShipTo;
